import type { DeviceModel } from '../../types/deviceModel';
import { powerPort, simpleLayout } from './layoutHelpers';

export const psu24vModel: DeviceModel = {
  equipmentId: 'psu-24v-30w',
  selfDrawWatts: 0,
  isPsu: true,
  psuOutput: { voltage: 24, watts: 30 },
  powerOutputs: [{ id: 'dc-out', kind: 'dc', voltageMin: 24, voltageMax: 24, maxWatts: 30, portNumber: 1 }],
  powerInputs: [{ id: 'ac', kind: 'ac', maxWatts: 40 }],
  layout: {
    simple: simpleLayout(
      [powerPort({ number: 1, kind: 'dc', label: '24V out', x: 18, y: 22 })],
      140,
      70
    ),
  },
};

export const psu48vModel: DeviceModel = {
  equipmentId: 'psu-48v-96w',
  selfDrawWatts: 0,
  isPsu: true,
  psuOutput: { voltage: 48, watts: 96 },
  powerOutputs: [{ id: 'dc-out', kind: 'dc', voltageMin: 48, voltageMax: 48, maxWatts: 96, portNumber: 1 }],
  powerInputs: [{ id: 'ac', kind: 'ac', maxWatts: 110 }],
  layout: {
    simple: simpleLayout(
      [powerPort({ number: 1, kind: 'dc', label: '48V out', x: 18, y: 22 })],
      140,
      70
    ),
  },
};

export const psu48v150Model: DeviceModel = {
  equipmentId: 'psu-48v-150w',
  selfDrawWatts: 0,
  isPsu: true,
  psuOutput: { voltage: 48, watts: 150 },
  powerOutputs: [{ id: 'dc-out', kind: 'dc', voltageMin: 48, voltageMax: 48, maxWatts: 150, portNumber: 1 }],
  powerInputs: [{ id: 'ac', kind: 'ac', maxWatts: 170 }],
  layout: {
    simple: simpleLayout(
      [powerPort({ number: 1, kind: 'dc', label: '48V out', x: 18, y: 22 })],
      140,
      70
    ),
  },
};

export const PSU_CATALOG: DeviceModel[] = [psu24vModel, psu48vModel, psu48v150Model];
